import { render, staticRenderFns } from "./FullSwiperV1.vue?vue&type=template&id=52811ba5&scoped=true&"
import script from "./FullSwiperV1.vue?vue&type=script&lang=js&"
export * from "./FullSwiperV1.vue?vue&type=script&lang=js&"
import style0 from "./FullSwiperV1.vue?vue&type=style&index=0&id=52811ba5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52811ba5",
  null
  
)

export default component.exports